import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { QuoteBanner } from '../components/ui/QuoteBanner';
import { ServiceSection } from '../components/services/ServiceSection';
import { useSeo } from '../hooks/useSeo';
import { pageMeta } from '../data/seo';
import { services } from '../data/services';
import { images } from '../data/images';
export function Services() {
  useSeo(pageMeta.services);
  return <>
      <PageHero title="Construction & civil engineering services" intro="Roadworks, civil infrastructure, water and sanitation, drainage, buildings and paving, delivered across Botswana." image={images.roadGrader} breadcrumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Services'
    }]} data-id="element-841" data-mp="14acpdzmg8he" />
      <nav aria-label="Services on this page" className="sticky top-[96px] lg:top-[136px] z-30 border-b border-white/10 bg-charcoal-950" data-id="element-842" data-mp="62val6reig2o">
        <ul className="mx-auto flex max-w-site gap-1 overflow-x-auto px-5 md:px-8" data-id="element-843" data-mp="27wukposserds">
          {services.map(service => <li key={service.id} className="shrink-0" data-id="element-844" data-mp="16q47sk1iomks">
              <a href={`#${service.id}`} className="block px-3 py-4 font-display text-[14px] font-semibold uppercase tracking-[0.08em] text-steel-300 transition-colors duration-150 hover:text-white" data-id="element-845" data-mp="1bnnyijfeirtm">
                {service.title}
              </a>
            </li>)}
        </ul>
      </nav>
      {services.map((service, index) => <ServiceSection key={service.id} service={service} reversed={index % 2 === 1} data-id="element-846" data-mp="1uef3z9w9py2q" data-mpi={index} />)}
      <QuoteBanner data-id="element-847" data-mp="1zdia6xnziaca" />
    </>;
}